<div class="page-content">
  <div class="page_header">
    <div class="page_header_text">
      <h1>Contratos</h1>
      <span>Gestão de contratos com clientes</span>
    </div>
    <div class="page_header_actions">
      <button class="btn-web-primary" (click)="openNew()">
        <i class="fas fa-plus"></i> Novo Contrato
      </button>
    </div>
  </div>

  <!-- TABELA -->
  <div class="data-table-wrapper">
    <table class="data-table" *ngIf="!loading && contratos.length > 0">
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Tipo de Serviço</th>
          <th>Valor Mensal</th>
          <th>Início</th>
          <th>Fim</th>
          <th>Postos</th>
          <th>Estado</th>
          <th>Acções</th>
        </tr>
      </thead>
      <tbody>
        @for (c of contratos; track c.id) {
          <tr>
            <td>
              <div class="client-cell">
                <div class="client-av">
                  {{ getClienteNome(c).slice(0, 2).toUpperCase() }}
                </div>
                <span>{{ getClienteNome(c) }}</span>
              </div>
            </td>
            <td>{{ c.tipoServicoDescricao ?? "—" }}</td>
            <td class="valor-cell">{{ formatKz(c.valorMensal) }}</td>
            <td>{{ c.inicioContrato | date: "dd/MM/yyyy" }}</td>
            <td>{{ c.fimContrato | date: "dd/MM/yyyy" }}</td>
            <td>
              <span class="postos-badge">{{ c.numPostos ?? "—" }}</span>
            </td>
            <td>
              <app-status-badge
                [value]="getEstado(c)"
                type="contrato"
              ></app-status-badge>
            </td>
            <td class="actions">
              <button
                class="btn-secondary icon-btn"
                (click)="openEdit(c)"
                title="Editar"
              >
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button
                class="btn-danger icon-btn"
                (click)="confirmDelete(c)"
                title="Eliminar"
              >
                <i class="fas fa-trash-alt"></i>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-empty-state
      *ngIf="!loading && contratos.length === 0"
      icon="fas fa-file-invoice"
      title="Nenhum contrato registado"
      actionLabel="Novo Contrato"
      (action)="openNew()"
    >
    </app-empty-state>

    <div *ngIf="loading" class="skeleton-rows">
      @for (i of [1, 2, 3, 4, 5]; track i) {
        <p-skeleton height="44px" styleClass="mb-2"></p-skeleton>
      }
    </div>
  </div>

  <!-- DRAWER -->
  <p-drawer
    [header]="editing ? 'Editar Contrato' : 'Novo Contrato'"
    [(visible)]="showDialog"
    position="right"
    [modal]="true"
    [style]="{ width: '680px' }"
    styleClass="efetivo-drawer-dark"
  >
    <form [formGroup]="form" class="dialog-form">
      <!-- CLIENTE SELECT -->
      <div class="form-group">
        <label>Cliente <span class="req">*</span></label>
        <p-select
          formControlName="idCliente"
          [options]="clientes"
          optionLabel="nome"
          optionValue="id"
          placeholder="Seleccionar cliente"
          [filter]="true"
          filterPlaceholder="Pesquisar cliente..."
          styleClass="w-full"
          appendTo="body"
        >
          <ng-template pTemplate="selectedItem" let-c>
            <div class="client-opt" *ngIf="c">
              <div class="client-av-sm">
                {{ c.nome.slice(0, 2).toUpperCase() }}
              </div>
              <div>
                <div style="font-weight: 500">{{ c.nome }}</div>
                <div
                  style="font-size: 11px; color: var(--sp-muted)"
                  *ngIf="c.nif"
                >
                  NIF: {{ c.nif }}
                </div>
              </div>
            </div>
          </ng-template>
          <ng-template pTemplate="item" let-c>
            <div class="client-opt">
              <div class="client-av-sm">
                {{ c.nome.slice(0, 2).toUpperCase() }}
              </div>
              <div>
                <div style="font-weight: 500">{{ c.nome }}</div>
                <div
                  style="font-size: 11px; color: var(--sp-muted)"
                  *ngIf="c.nif"
                >
                  NIF: {{ c.nif }}
                </div>
              </div>
            </div>
          </ng-template>
        </p-select>
        <small
          class="field-error"
          *ngIf="
            form.get('idCliente')?.invalid && form.get('idCliente')?.touched
          "
          >Campo obrigatório</small
        >
      </div>

      <!-- Preview do cliente seleccionado -->
      <div class="client-preview" *ngIf="selectedCliente">
        <i class="fas fa-building"></i>
        <span>{{ selectedCliente.nome }}</span>
        <span class="sep">·</span>
        <span *ngIf="selectedCliente.nif">NIF {{ selectedCliente.nif }}</span>
        <span *ngIf="selectedCliente.nomeResponsavel"
          >· Resp: {{ selectedCliente.nomeResponsavel }}</span
        >
      </div>

      <div class="form-divider"></div>

      <!-- Valor + Postos -->
      <p class="form-section-title">Condições Contratuais</p>
      <div class="form-grid-2">
        <div class="form-group">
          <label>Valor Mensal (Kz) <span class="req">*</span></label>
          <p-inputnumber
            formControlName="valorMensal"
            [min]="1"
            styleClass="w-full"
            suffix=" Kz"
            [useGrouping]="true"
          >
          </p-inputnumber>
          <small
            class="field-error"
            *ngIf="
              form.get('valorMensal')?.invalid &&
              form.get('valorMensal')?.touched
            "
            >Campo obrigatório</small
          >
        </div>
        <div class="form-group">
          <label>Nº de Postos</label>
          <p-inputnumber
            formControlName="numPostos"
            [min]="1"
            [showButtons]="true"
            styleClass="w-full"
          >
          </p-inputnumber>
        </div>
      </div>

      <!-- Datas -->
      <p class="form-section-title">Período do Contrato</p>
      <div class="form-grid-2">
        <div class="form-group">
          <label>Data de Início <span class="req">*</span></label>
          <p-datepicker
            formControlName="inicioContrato"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small
            class="field-error"
            *ngIf="
              form.get('inicioContrato')?.invalid &&
              form.get('inicioContrato')?.touched
            "
            >Campo obrigatório</small
          >
        </div>
        <div class="form-group">
          <label>Data de Fim <span class="req">*</span></label>
          <p-datepicker
            formControlName="fimContrato"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [minDate]="form.get('inicioContrato')?.value"
            styleClass="w-full"
            appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
          >
          </p-datepicker>
          <small
            class="field-error"
            *ngIf="
              form.get('fimContrato')?.invalid &&
              form.get('fimContrato')?.touched
            "
            >Campo obrigatório</small
          >
        </div>
      </div>

      <div class="form-group">
        <label>Data de Facturação</label>
        <p-datepicker
          formControlName="dataFaturacao"
          dateFormat="dd/mm/yy"
          [showIcon]="true"
          styleClass="w-full"
          appendTo="body" [autoZIndex]="true" [baseZIndex]="1000010" panelStyleClass="drawer-datepicker-panel"
        >
        </p-datepicker>
      </div>
    </form>

    <ng-template pTemplate="footer">
      <button type="button" class="btn-web-secondary" (click)="showDialog = false">
        Cancelar
      </button>
      <button class="btn-web-primary" (click)="save()">
        <i class="fas fa-save"></i> Guardar
      </button>
    </ng-template>
  </p-drawer>
</div>
